"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApiError = void 0;
const handled_error_1 = require("./handled.error");
class ApiError extends handled_error_1.HandledError {
    constructor(message, code, data) {
        super(message);
        this.message = message;
        this.code = code;
        this.data = data;
    }
    get body() {
        return {
            message: this.message,
            code: this.code,
            data: this.data,
        };
    }
}
exports.ApiError = ApiError;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiYXBpLmVycm9yLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL2FwaS5lcnJvci50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFBQSxtREFBOEM7QUFFOUMsTUFBYSxRQUE4QixTQUFRLDRCQUFZO0lBQzdELFlBQTRCLE9BQWUsRUFBa0IsSUFBTyxFQUFrQixJQUFPO1FBQzNGLEtBQUssQ0FBQyxPQUFPLENBQUMsQ0FBQTtRQURZLFlBQU8sR0FBUCxPQUFPLENBQVE7UUFBa0IsU0FBSSxHQUFKLElBQUksQ0FBRztRQUFrQixTQUFJLEdBQUosSUFBSSxDQUFHO0lBRTdGLENBQUM7SUFFRCxJQUFJLElBQUk7UUFDTixPQUFPO1lBQ0wsT0FBTyxFQUFFLElBQUksQ0FBQyxPQUFPO1lBQ3JCLElBQUksRUFBRSxJQUFJLENBQUMsSUFBSTtZQUNmLElBQUksRUFBRSxJQUFJLENBQUMsSUFBSTtTQUNoQixDQUFBO0lBQ0gsQ0FBQztDQUNGO0FBWkQsNEJBWUMifQ==